import VerigramIcon from "../assets/icons/VerigramIcon";
import FacetecIcon from "../assets/icons/FacetecIcon";

export const VENDOR_MAPPING = {
    vg: {
        name: "Verigram",
        Icon: VerigramIcon
    },
    ft: {
        name: "Facetec",
        Icon: FacetecIcon
    }
};

export const DEFAULT_VENDOR_INFO = {
    name: null,
    Icon: null
};
